import { takeLatest, put, call } from 'redux-saga/effects';
import { AdditionalExercisesTypes, AdditionalExercisesAction, AdditionalExercise } from '../types';
import { saveAdditionalExercise, getList, deleteExercise } from '../actions';
import {
    deleteAdditionalExerciseFirebase,
    getAdditionalExercisesFirebase,
    saveAdditionalExerciseFirebase,
} from '../repository';
import { requestSaveAdditionalStage } from '../../additionalStages/actions';
import { AdditionalStage } from '../../additionalStages/types';
import { requestDeleteTasks } from '../../tasks/actions';

const getNewExercisesList = (exerciseId: string, exercises?: string[]) => {
    if (!exercises) return [exerciseId];
    if (exercises.includes(exerciseId)) return exercises;
    return [...exercises, exerciseId];
};

export function* requestGetListSaga(props: AdditionalExercisesAction<{ ids: string[] }>): unknown {
    try {
        const additionalStages = yield call(getAdditionalExercisesFirebase, props.payload.ids);
        yield put(getList(additionalStages));
    } catch (err: unknown) {
        yield put(getList([]));
    }
}

export function* requestSaveAdditionalExerciseSaga(
    props: AdditionalExercisesAction<{ additionalStage: AdditionalStage; additionalExercise: AdditionalExercise }>,
): unknown {
    try {
        const additionalExercise = yield call(saveAdditionalExerciseFirebase, props.payload.additionalExercise);
        yield put(saveAdditionalExercise(additionalExercise));
        yield put(
            requestSaveAdditionalStage({
                ...props.payload.additionalStage,
                additionalExercises: getNewExercisesList(
                    additionalExercise.id,
                    props.payload.additionalStage.additionalExercises,
                ),
            }),
        );
    } catch (err: unknown) {
        yield put(saveAdditionalExercise());
    }
}

export function* requestDeleteAdditionalExerciseSaga(
    props: AdditionalExercisesAction<{ id: string; tasks: string[] }>,
): unknown {
    try {
        const tasks = props.payload.tasks;
        const id = yield call(deleteAdditionalExerciseFirebase, props.payload.id);
        yield put(deleteExercise(id));
        if (tasks && tasks.length > 0) yield put(requestDeleteTasks(tasks));
    } catch (err: unknown) {
        yield put(deleteExercise());
    }
}

export default [
    takeLatest(AdditionalExercisesTypes.REQUEST_GET_LIST, requestGetListSaga),
    takeLatest(AdditionalExercisesTypes.REQUEST_SAVE_ADDITIONAL_EXERCISE, requestSaveAdditionalExerciseSaga),
    takeLatest(AdditionalExercisesTypes.REQUEST_DELETE_EXERCISE, requestDeleteAdditionalExerciseSaga),
];
